import { RefObject, useState } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

function useIsOverflow<T extends HTMLElement = HTMLElement>(ref: RefObject<T>): boolean {
  const [isOverflow, setIsOverflow] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const { current } = ref;

    const isElementOverflow = () => {
      setIsOverflow((current?.scrollHeight || 0) > (current?.clientHeight || 0));
    };

    const observer = (window !== undefined && 'ResizeObserver' in window) ?
      new ResizeObserver(isElementOverflow) : undefined;
    observer?.observe(current as T);

    isElementOverflow();

    return () => {
      // Cleanup the observer by unobserving all elements
      observer?.disconnect()
    }
  }, [ref]);

  return isOverflow;
};

export default useIsOverflow;
